// extracted by mini-css-extract-plugin
module.exports = {"item":"CartInformationForm_item__28JKU","btn_submit":"CartInformationForm_btn_submit__B81IS","container":"CartInformationForm_container__eATyC"};